import { gql } from "@apollo/client";

export const GET_LAST_EXECUTIONS = gql`
  query GetLastExecutions($userID: ID!, $limit: Int) {
    getLastExecutions(userID: $userID, limit: $limit) {
      id
      language
      code_snippet
      started_at
      ended_at
      status
      error_message
    }
  }
`;
